import { type RouteRecordRaw } from 'vue-router';

export const homeRoutes: RouteRecordRaw[] = [{
    path: 'home',
    name: 'home',
    meta: {
        showInMenu: true,
        categoryIndex: 0,
        index: 0,
        prependIcon: 'icon-dashboard',
        code: 'core.routes.menu.home'
    },
    component: () => import('./views/HomeView.vue')
}, {
    path: 'home/fleet',
    name: 'fleet',
    redirect: { name: 'fleet.spots' },
    meta: {
        showInMenu: true,
        hasTabs: true,
        categoryIndex: 0,
        index: 1,
        prependIcon: 'icon-eye',
        code: 'core.routes.menu.fleet'
    },
    component: () => import('./views/FleetView.vue'),
    children: [{
        path: 'spots',
        name: 'fleet.spots',
        meta: {
            showInTabs: true,
            index: 0,
            code: 'core.routes.fleet.spots'
        },
        component: () => import('./views/fleet/SpotsView.vue')
    }, {
        path: 'locations',
        name: 'fleet.locations',
        meta: {
            showInTabs: true,
            index: 1,
            code: 'core.routes.fleet.locations'
        },
        component: () => import('./views/fleet/LocationsView.vue')
    }]
}];